import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_provision_ppe_equipment_such_as_hearing_protection'

export const dataPointDefinition = {
  retracedId: 'no_provision_ppe_equipment_such_as_hearing_protection',
  name: 'No provision of PPE equipment (such as hearing protection) where noise levels approach or exceed the equivalent dose of ',
  description:
    'The intent of this option selection is to understand if PPE equipment (such as hearing protection) is provided to protect all workers who need PPE.',
  meta: {
    slcpMeta: {
      key: 'hs-wor-21x',
      number: 'HS-WOR-8-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-21x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31650,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
